export default __webpack_public_path__ + "static/blob-gradient-452dcc60db027e42f81a2263dad94883.png";